import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import {
  Pagination,
  SearchFilter,
  FilterSelect,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { matchesString } from "LIB/filters";
import { Search as SearchProp } from "MODULES/shared/components";
import ExportButton from "MODULES/MyShoppingList/Search/ExportButton";
import Table from "./Table";
import shoppingListPagination from "../pagination";

const defaultFilters = {
  tier_type: undefined
};

const orderFilter = {
  sort: "most_recent_sale_date"
};

const filters = [
  {
    label: "Show All Tier Types",
    filters: { ...defaultFilters, ...orderFilter }
  },
  {
    label: "5 Star",
    filters: { ...orderFilter, tier_type: "SATL" }
  },
  {
    label: "4 Star",
    filters: { ...orderFilter, tier_type: "ATL" }
  },
  {
    label: "3 Star",
    filters: { ...orderFilter, tier_type: "BTL" }
  },
  {
    label: "2 Star",
    filters: { ...orderFilter, tier_type: "BBTL" }
  },
  {
    label: "1 Star",
    filters: { ...orderFilter, tier_type: "ZTL" }
  }
];

const filterTags = [
  {
    label: "5 Star",
    key: "tier_type",
    matchesTarget: matchesString("SATL")
  },
  {
    label: "4 Star",
    key: "tier_type",
    matchesTarget: matchesString("ATL")
  },
  {
    label: "3 Star",
    key: "tier_type",
    matchesTarget: matchesString("BTL")
  },
  {
    label: "2 Star",
    key: "tier_type",
    matchesTarget: matchesString("BBTL")
  },
  {
    label: "1 Star",
    key: "tier_type",
    matchesTarget: matchesString("ZTL")
  },
  {
    label: "NAP Records",
    key: "nap_records"
  }
];

function Search({ pushHistory }) {
  return (
    <SearchProp search={shoppingListPagination} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing a Part Number..."
                submitOnSingleResult={p => pushHistory(`/parts/${p.id}`)}
              />
              <ExportButton searchProps={searchProps} />
              <FilterSelect {...searchProps} filters={filters} right />
            </div>
          </div>
          <TitleWithFilters
            {...searchProps}
            title="My Shopping List"
            filters={filterTags}
          />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </SearchProp>
  );
}

Search.propTypes = {
  pushHistory: PropTypes.func.isRequired
};

export default connect(undefined, { pushHistory: push })(Search);



// WEBPACK FOOTER //
// ./app/modules/MyShoppingList/Search/Search.jsx